import { useCallback, useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiRightDrawer } from "../../../../components";
import { APICallFunction, APIParams } from "../../role/apiCall";
import { addUserRoleMapping, deleteUserRoleMapping, getUserRoleMapping, userNotInRoles } from "../apiCall";
import { UserKeys } from "../entity";
import CheckListSearch from "../../../../components/CheckListSearch";

export const UserRoleMapping = (props: any) => {
  const { request } = props;
  const [open, setOpen] = useState(false);

  const onClose = (e: any) => {
    setOpen(false);
  }

  const onSubmit: APICallFunction = useCallback(async (params) => {
    const res: any = await addUserRoleMapping({ ...params, request: { ...params.request, ...request } });
    return res;
  }, [request])

  const getOptions = useCallback(async (params: APIParams) => await userNotInRoles({ ...params, request: { ...params.request, ...request } }), [request])

  return (
    <>
      <CatalogBuilder
        isHeader={false}
        isRightMenu={true}
        isAssociationButton={true}

        getPagingData={getUserRoleMapping}
        pagingAPIrequest={request}
        pagingAPIKey={UserKeys.getRoleMapping}

        onDelete={deleteUserRoleMapping}  //temporary..
        deletePagingAPIKey={UserKeys.deleteRoleMapping}   //temporary..

        visibleColumns={{
          IdentityName: false
        }}
        onClickPlus={() => { setOpen(true) }}
        disableEditAction={true}
        disableViewAction={true}
      />

      <MuiRightDrawer open={open} onClose={onClose} width="40%">
        <CheckListSearch
          getOptions={getOptions}
          displayExpr={'DisplayName'}
          listKey={UserKeys.notInRoles}
          label='Add Roles'
          name='RoleId'
          onSubmit={onSubmit}
          onClose={onClose}
          pagingAPIKey={UserKeys.getRoleMapping}
        />
      </MuiRightDrawer>
    </>
  );
};
